<template>
  <duration-input
    :value="value"
    label="Fahrtzeit"
    :hide-details="hideDetails"
    :disabled="disabled"
    :loading="loading"
    @input="onInput"
  />
</template>

<script>
import DurationInput from '../selects/Duration'

export default {
  components: {
    'duration-input': DurationInput
  },
  props: [
    'disabled',
    'hideDetails',
    'loading',
    'value',
  ],
  methods: {
    onInput (value) {
      this.$emit('input', value)
    }
  }
}
</script>
